import { listBacSy1, listGender } from "data/list";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const { INPUT, SELECT, DATE, COMBO_BOX, AUTO_COMPLETE } = FIELD_TYPE;
const fields = () => {
  const fields: DataFormField[] = [
    {
      type: DATE,
      label: "Ngày tạo",
      name: "ngayTao",
      optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
      disable: true,
    },
    {
      type: INPUT,
      label: "Số điện thoại",
      name: "dienThoai",
      disable: true,
    },
    {
      type: INPUT,
      label: "Địa chỉ",
      name: "diaChiTongHop",
      disable: true,
    },

    {
      type: SELECT,
      label: "Loại KCB",
      name: "loaiKCB",
      disable: true,
      options: JSON.parse(localStorage.getItem("loaiKCB")),
      placeholder: "Không có",
    },
    {
      type: INPUT,
      label: "Thân nhân",
      name: "thanNhan",
      disable: true,
    },
    {
      type: COMBO_BOX,
      label: "Người thực hiện",
      name: "nvThucHien",
    },
    {
      type: SELECT,
      label: "Trạng thái CĐHA",
      name: "trangThai",
      disable: true,
      options: JSON.parse(localStorage.getItem("TTPhieu")),
      placeholder: "Không có",
    },

    {
      type: INPUT,
      label: "Lý do khám",
      // css: {
      //   xl: 16,
      //   lg: 12,
      //   md: 24,
      //   sm: 24,
      //   xs: 24,
      // },
      // labelCol: { xs: 10, md: 8, lg: 8, xl: 3 },
      // wrapperCol: { xs: 14, md: 16, lg: 16, xl: 21 },
      name: "lyDoKham",
      disable: true,
    },
    {
      type: DATE,
      label: "TG chỉ định",
      name: "thoiGianChiDinh",
      disable: true,
      optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
    },
  ];
  return fields;
};
export { fields };
